export interface OptionBuyBackExportExcelReq {
  heading: string;
  data: any;
  headers: any;
}

export interface Header {
  key: string;
  value: string;
}

export const buyBackHeadingVal: string = "Employees";
export const buyBackHeadersObj: any = {
  employeeName: "EMPLOYEE NAME",
  granted: "GRANTED OPTIONS",
  vested: "VESTED OPTIONS",
  exercised: "EXERCISED OPTIONS",
  eligibility: "ELIGIBILITY",
  willingness: "WILLINGNESS",
  state: "STATUS",
  totalPriceToPay: "TOTAL STRIKE PRICE",
  totalValueWillingness: "TOTAL CASHOUT AMOUNT",
  totalTaxPercentageSlab: "PERQUISITE TAX(%)",
  surchargePercentage: "SURCHARGE TAX(%)",
  cessChargePercentage: "CESS TAX(%)",
  perquisiteTaxAmount: "TOTAL TAX",
  netPayout: "NET PAYOUT AMOUNT",
  hrId: "HR ID",
};
export const buyBackHeaderslist: string[] = [
  "hrId",
  "employeeName",
  "state",
  "granted",
  "vested",
  "exercised",
  "eligibility",
  "willingness",
  "totalTaxPercentageSlab",
  "surchargePercentage",
  "cessChargePercentage",
  "totalValueWillingness",
  "totalPriceToPay",
  "perquisiteTaxAmount",
  "netPayout",
];
